export default {
  // App
  "appTitle": "Chronomètre et Minuteur multifonction",
  "siteIntro": "Créez et gérez des chronomètres et des minuteurs personnalisables avec plusieurs effets visuels et notifications",
  
  // General
  "cancel": "Annuler",
  "save": "Enregistrer",
  "start": "Démarrer",
  "pause": "Pause",
  "stop": "Arrêter",
  "reset": "Réinitialiser",
  "add": "Ajouter",
  "edit": "Modifier",
  "delete": "Supprimer",
  "confirm": "Confirmer",
  "close": "Fermer",
  "back": "Retour",
  "submit": "Soumettre",
  "timer": "Minuteur",
  "optional": "Optionnel",
  "clickAgainToDelete": "Cliquez à nouveau pour supprimer",
  "fullscreen": "Plein écran",
  "exitFullscreen": "Quitter le plein écran",
  
  // Timer modes
  "countdown": "Compte à rebours",
  "stopwatch": "Chronomètre",
  
  // TimersContainer
  "myTimers": "Mes minuteurs",
  "addTimer": "Ajouter un minuteur",
  "noTimers": "Pas encore de minuteurs",
  "createFirstTimer": "Créer votre premier minuteur",
  
  // TimerForm
  "createTimer": "Créer un minuteur",
  "editTimer": "Modifier le minuteur",
  "timerName": "Nom du minuteur",
  "timerNamePlaceholder": "Entrez le nom du minuteur",
  "timerMode": "Mode du minuteur",
  "duration": "Durée",
  "hours": "Heures",
  "minutes": "Minutes",
  "seconds": "Secondes",
  "showMilliseconds": "Afficher les millisecondes",
  
  // Settings
  "settings": "Paramètres",
  "darkMode": "Mode sombre",
  "language": "Langue",
  "notificationSound": "Son de notification",
  "enableNotifications": "Activer les notifications",
  "english": "Anglais",
  "chinese": "Chinois",
  "spanish": "Espagnol",
  "french": "Français",
  "japanese": "Japonais",
  
  // Notification sounds
  "default": "Par défaut",
  "bell": "Cloche",
  "digital": "Numérique",
  "chime": "Carillon",
  "none": "Aucun",
  
  // Messages
  "timerComplete": "Minuteur terminé !",
  
  // Effects
  "effect": "Effet",
  "effectSettings": "Paramètres d'effet",
  "effectType": "Type d'effet",
  "opacity": "Opacité",
  "speed": "Vitesse",
  "primaryColor": "Couleur primaire",
  "secondaryColor": "Couleur secondaire",
  "circle": "Cercle",
  "wave": "Vague",
  "pulse": "Pulsation",
  "particles": "Particules",
  "gradient": "Dégradé",
  "ripple": "Ondulation",
  
  // About page
  "about": "À propos",
  "aboutTitle": "À propos de cette application",
  "aboutIntroTitle": "Bienvenue sur le Chronomètre et Minuteur multifonction",
  "aboutIntroText": "Cette application web vous permet de créer et de gérer plusieurs chronomètres et minuteurs personnalisables. Que vous ayez besoin de suivre des séances d'exercice, des temps de cuisson ou des intervalles de productivité, cet outil offre une solution flexible et facile à utiliser.",
  
  "aboutFeaturesTitle": "Fonctionnalités principales",
  "aboutFeatureTimersTitle": "Minuteurs et chronomètres",
  "aboutFeatureTimersText": "Créez à la fois des minuteurs à compte à rebours et des chronomètres. Les minuteurs à compte à rebours vous permettent de définir des heures, des minutes et des secondes, tandis que les chronomètres enregistrent le temps écoulé à partir de zéro.",
  
  "aboutFeatureNotificationsTitle": "Notifications",
  "aboutFeatureNotificationsText": "Recevez des alertes audiovisuelles lorsque vos minuteurs sont terminés. Choisissez parmi plusieurs sons de notification ou optez pour un fonctionnement silencieux.",
  
  "aboutFeatureEffectsTitle": "Effets visuels",
  "aboutFeatureEffectsText": "Personnalisez vos minuteurs avec différents effets visuels comme des cercles, des vagues, des pulsations, des particules et des dégradés. Ajustez l'opacité, la vitesse et les couleurs selon vos préférences.",
  
  "aboutFeatureShortcutsTitle": "Raccourcis clavier",
  "aboutFeatureShortcutsText": "Contrôlez vos minuteurs efficacement avec des raccourcis clavier pour démarrer, mettre en pause, arrêter et réinitialiser.",
  
  "aboutFeatureLanguagesTitle": "Support multilingue",
  "aboutFeatureLanguagesText": "Utilisez l'application dans votre langue préférée. Elle prend actuellement en charge l'anglais, le chinois, l'espagnol, le français et le japonais.",
  
  "aboutFeatureDarkModeTitle": "Mode sombre",
  "aboutFeatureDarkModeText": "Basculez entre les thèmes clairs et sombres pour réduire la fatigue oculaire et économiser la batterie sur les appareils OLED.",
  
  "aboutHowToUseTitle": "Comment utiliser",
  "aboutHowToCreateTitle": "Créer un minuteur",
  "aboutHowToCreateText": "Cliquez sur le bouton \"Ajouter un minuteur\", entrez un nom, sélectionnez le mode du minuteur (compte à rebours ou chronomètre), définissez la durée (pour le compte à rebours) et personnalisez les effets visuels. Cliquez sur \"Enregistrer\" lorsque vous avez terminé.",
  
  "aboutHowToControlTitle": "Contrôler les minuteurs",
  "aboutHowToControlText": "Utilisez les boutons de contrôle pour démarrer, mettre en pause, arrêter et réinitialiser vos minuteurs. Vous pouvez également basculer en mode plein écran pour une meilleure visibilité.",
  
  "aboutHowToCustomizeTitle": "Personnaliser les effets",
  "aboutHowToCustomizeText": "Lors de la création ou de la modification d'un minuteur, sélectionnez un type d'effet et ajustez son apparence à l'aide des contrôles d'opacité, de vitesse et de couleur.",
  
  "aboutHowToManageTitle": "Gérer les minuteurs",
  "aboutHowToManageText": "Modifiez les minuteurs existants en cliquant sur l'icône de modification. Supprimez les minuteurs en cliquant deux fois sur l'icône de suppression. Tous vos minuteurs sont automatiquement enregistrés et seront disponibles lorsque vous reviendrez.",
  
  "aboutProjectTitle": "À propos du projet",
  "aboutProjectText": "Ce projet a été développé comme une application web moderne utilisant React, TypeScript et diverses bibliothèques pour les animations et la gestion d'état.",
  
  "aboutVersionInfo": "Version 1.0.0"
}; 